/**
 * Store v2 Precios Modelos - Planes de Ahorro
 * Usa API /pa/preciosModelosV2 (getModelosByFamilia, filtros consistentes).
 */
import { API_URL } from '../../../config'
import store from '../../store'

const BASE = `${API_URL}/pa/preciosModelosV2`

async function request(path, options = {}) {
  const url = `${BASE}${path}`
  const headers = {
    'Content-Type': 'application/json',
    Authorization: store.state.token,
    ...options.headers
  }
  try {
    const res = await fetch(url, { ...options, headers })
    return res.json()
  } catch (err) {
    return { exito: 0, message: err.message }
  }
}

export default {
  namespaced: true,
  actions: {
    async getModelosByFamilia(_, familiaId) {
      return request('/modelosByFamilia', {
        method: 'POST',
        body: JSON.stringify({ familiaId: familiaId ?? null })
      })
    },
    async getModelos(_, payload) {
      return request('/modelos', {
        method: 'POST',
        body: JSON.stringify(payload)
      })
    },
    async getPreciosModelos(_, payload) {
      return request('/precios', {
        method: 'POST',
        body: JSON.stringify(payload)
      })
    },
    async postPreciosModelos(_, payload) {
      return request('/nuevo', {
        method: 'POST',
        body: JSON.stringify(payload)
      })
    },
    async eliminarPrecioModelo(_, payload) {
      return request('/eliminarPrecio', {
        method: 'POST',
        body: JSON.stringify(payload)
      })
    },
    async postPreciosMasivo(_, payload) {
      return request('/preciosMasivo', {
        method: 'POST',
        body: JSON.stringify(payload)
      })
    },
    async editarPrecioModelo(_, payload) {
      return request('/editarPrecio', {
        method: 'POST',
        body: JSON.stringify(payload)
      })
    },
    async postPreciosModelosBatch(_, payload) {
      return request('/nuevoBatch', {
        method: 'POST',
        body: JSON.stringify(payload)
      })
    }
  }
}
